// extracted by mini-css-extract-plugin
export default {"root":"yF3srTLn","root__optical_compensation":"j59gg3Ma","children":"G9ofecbU","root__align_left":"_7VK_i9QR","root__align_right":"clUdPMvI","root__align_center":"zX5I9Deq"};